module.exports = __webpack_public_path__ + "static/img/home_05.7769af3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/home_05.jpg
// module id = QH7h
// module chunks = 1